export enum EVENTS {
  APP_URL_OPEN = 'appUrlOpen',
  KEYBOARD_WILL_SHOW = 'keyboardWillShow',
  KEYBOARD_WILL_HIDE = 'keyboardWillHide',
  NETWORK_STATUS_CHANGE = 'networkStatusChange',
}

export enum LOCALSTORAGE {
  TOKEN = 'cheerie.token',
  INSTALL_ID = 'cheerie.install_id',
  ONBOARDING = 'cheerie.onboarding',
  POINTS = 'cheerie.points',
}

export enum LOCALES {
  EN_US = 'en-US',
}
